module.exports = __webpack_public_path__ + "static/img/code.15232474.png";